<template>
  <div v-if="userProfile.userType">

    <v-bottom-navigation app grow   color="primary">
      <template v-if="((userProfile || {}).userType || {}).hefe">
        <v-btn router :to="'/dashboard'">
          <v-icon large>home</v-icon>
        </v-btn>
        <v-btn router :to="'/hefe/payments'">
          <v-icon large>bar_chart</v-icon>
        </v-btn>
        <v-btn @click.native="dialog = true">
          <!-- <img src="@/assets/plus-square.svg" alt="" height="36" class="pt-1"> -->
          <v-icon large :color="$vuetify.theme.dark?'grey lighten-1':'grey darken-2'">post_add</v-icon>
        </v-btn>
        <v-btn router :to="'/hefe/favorites'">
          <v-icon large>group</v-icon>
        </v-btn>
      </template>

      <template v-if="((userProfile || {}).userType || {}).obr">
        <v-btn router :key="i" :to="item.action" v-for="(item, i) in obrNav">
          <!-- <span>{{item.title}}</span> -->
          <v-icon v-html="item.icon" class="pt-1" large></v-icon>
        </v-btn>

      </template>
      <template v-if="((userProfile || {}).userType || {}).refer">
        <v-btn router :key="i" :to="item.action" v-for="(item, i) in referralNav" :disabled="!hasStripe" text>
          <!-- <span>{{item.title}}</span> -->
          <v-icon v-html="item.icon" class="pt-1" large v-if="item.icon ==='group'"></v-icon>
          <v-icon v-html="item.icon" class="pt-1" large v-else></v-icon>
        </v-btn>

      </template>
      <v-btn v-if="notificationCount">
        <v-menu transition="slide-x-reverse-transition" :close-on-content-click="false" offset-y>
          <template v-slot:activator="{on}">
            <v-row no-gutters align="center" v-on="on">
              <v-col cols="12" justify="center">
                <v-badge right top color="blue darken-1" overlap class="mb-1">
                  <template v-slot:badge>
                    {{ notificationCount }}
                  </template>
                  <v-icon :color="$vuetify.theme.dark?'grey lighten-1':'grey darken-2'" large>notifications</v-icon>
                </v-badge>
              </v-col>
            </v-row>
          </template>
          <v-card max-height="400" scrollable>
            <v-layout column full-width>
              <v-flex xs12>
                <v-list two-line>
                  <template v-for="(item, key, index) in (userProfile || {}).notifications">
                    <v-list-item :key="item.key">
                      <v-list-item-content @click="openNotificationDialog(item, key)">
                        <v-list-item-title>{{ $language.notifications[item.notificationType] }}
                          <span class="caption">{{ item.notificationDate | formatDateTime }}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{
                          Array.isArray(item.notificationText)
                            ? item.notificationText[0]
                            : item.notificationText
                        }}
                          {{
                          Array.isArray(item.notificationText) ? item.notificationText[1] : ''
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn text icon color="primary" @click="deleteNotification(item, key)">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider v-if="notificationCount - 1 !== index" :key="index"></v-divider>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card>
        </v-menu>
      </v-btn>
      <v-btn v-else>
        <v-icon class="mt-1" large disabled>notifications</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <v-dialog v-model="notificationDialog" max-width="320">
      <v-card v-if="thisNotification">
        <v-card-title class="headline">{{ $language.notifications[thisNotification.notificationType || ''] }}</v-card-title>
        <v-card-text class="body-1">
          {{ Array.isArray(thisNotification.notificationText) ? thisNotification.notificationText[0] : thisNotification.notificationText }} {{ Array.isArray(thisNotification.notificationText) ? thisNotification.notificationText[1] : '' }}
        </v-card-text>
        <v-card-text v-if="thisNotification.notificationType==='Payment'&&thisNotification.hefeRated=='false'">
          <span class="title">How was your experience?</span>
          <v-row align="center">
            <v-col cols="12" align="center">
              <v-rating size="24" large v-model="rating.rating" color="yellow darken-3" background-color="grey darken-1" empty-icon="$vuetify.icons.ratingEmpty"></v-rating>
              <v-textarea outlined label="Comments" v-model="rating.comment" class="mt-2"></v-textarea>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-row no-gutters align="center" justify="space-around" class="px-2">
            <v-col cols="5">
              <v-btn color="primary" block text @click.native="notificationDialog = false">{{$language.settings['Close']}}</v-btn>
            </v-col>
            <v-col cols="5">
              <v-btn color="primary" block @click.native="rate(thisNotification)" :disabled="rating.rating==null" v-if="thisNotification.notificationType==='Payment'&&thisNotification.hefeRated=='false'">{{$language.jobDetails['Rate']}}</v-btn>
              <v-btn color="primary" block @click.native="openDialog(thisNotification)" v-else>{{$language.settings['View']}}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="((userProfile || {}).userType || {}).hefe" v-model="dialog" hide-overlay fullscreen persistent transition="slide-y-transition">
      <add-job @simple-close="dialog = false" :is-hefe="true" :has-started="false"></add-job>
    </v-dialog>
    <v-snackbar v-model="snackbar.show" :color="snackbar.status" :timeout="1500">
      <span class="align-baseline">{{ snackbar.message }} <v-icon small>check</v-icon></span>

    </v-snackbar>
  </div>
</template>

<script>
import {
  mapGetters,
  mapState
} from 'vuex'
import AddJob from '@/components/common/AddJob'
import moment from 'moment'
const fb = require('@/services/firebaseConfig.js')

export default {
  components: {
    AddJob
  },
  props: ['routeName'],
  data () {
    return {
      dialog: false,
      clipped: false,
      drawer: false,
      fixed: true,
      notificationDialog: false,
      thisNotification: {
        notificationType: null,
        notificationText: null
      },
      route: this.routeName,
      bottomNav: '',
      hefeNav: [{
        icon: 'home',
        title: 'Home',
        action: '/dashboard'
      },
      {
        icon: 'bar_chart',
        title: this.$language.navigation['Payments'],
        action: '/hefe/payments'
      },
      {
        icon: 'group',
        title: this.$language.navigation['Favorites'],
        action: '/hefe/favorites'
      },
      {
        icon: 'add',
        action: '/dashboard'
      }
      ],
      obrNav: [{
        icon: 'home',
        title: 'Home',
        action: '/dashboard'
      },

      {
        icon: 'bar_chart',
        title: this.$language.navigation['Earnings'],
        action: '/obrero/earnings'
      },
      {
        icon: 'search',
        title: this.$language.navigation['Jobs'],
        action: '/obrero/job-search'
      }
      ],
      referralNav: [ {
        icon: 'dashboard',
        title: this.$language.navigation['Dashboard'],
        action: '/referral-dashboard'
      },
      {
        icon: 'group',
        title: this.$language.navigation['Referrals'],
        action: '/referrals'
      },
      {
        icon: 'bar_chart',
        title: this.$language.navigation['Earnings'],
        action: '/obrero/earnings'
      }],

      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Hefe',
      rating: {
        comment: '',
        rating: null,
        ratingDate: new Date()
      },
      snackbar: {
        show: false,
        message: '',
        status: 'success'
      }
    }
  },
  computed: {
    ...mapGetters(['getLanguage']),
    ...mapState(['userProfile', 'currentUser']),
    notificationCount () {
      if (this.userProfile.notifications !== undefined) {
        return Object.keys(this.userProfile.notifications).length
      }
      return 0
    },
    hasStripe () {
      return (((this.userProfile.stripeAccount || {}).account || {}).capabilities || {}).transfers === 'active' || false
    }
  },
  methods: {
    openNotificationDialog (notification, key) {
      this.thisNotification = notification
      this.thisNotification._key = key
      this.notificationDialog = true
    },
    async rate (data) {
      var updates = {}
      this.rating.ratedByName = this.userProfile.public.name
      this.rating.ratedById = this.currentUser.uid
      updates[`/jobs/${data.jobId}/applicants/${this.currentUser.uid}/hefeRated`] = true
      updates[`/user/${data.hefeId}/profile/public/ratings/${data.jobId}`] = this.rating
      updates[`user/${this.currentUser.uid}/profile/notifications/${data._key}/hefeRated`] = true
      await fb.database.ref().update(updates)
      this.rating = {
        comment: '',
        rating: null,
        ratingDate: new Date()
      }
      this.thisNotification.hefeRated = true
      this.snackbar.message = this.$language.jobDetails['Review submitted']
      this.snackbar.status = 'success'
      this.snackbar.show = true
    },
    openDialog (data) {
      this.thisJob = {
        _key: data.jobId,
        defaultTab: data.defaultTab
      }
      this.notificationDialog = false
      fb.database.ref(`jobs/${data.jobId}/public/createdBy`).once('value').then((snap) => {
        var createdBy = snap.val()
        if (createdBy === this.currentUser.uid) {
          this.$router.push(`/hefe/job-details/${data.jobId}?tab=${data.defaultTab}`)
        } else {
          this.$router.push(`/obrero/job-details/${data.jobId}?tab=${data.defaultTab}`)
        }
      })

      // this.dialogs['job-details'] = true
    },
    deleteNotification (notification, key) {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/notifications/${key}`] = null
      fb.database.ref().update(updates)
    },
    openAddDialog () {
      this.$store.dispatch('openAddDialog', true)
    },
    logout () {
      fb.app.auth().signOut().then(() => {
        this.$store.dispatch('clearData')
        this.$router.push('/login')
      }).catch(err => {
        console.log(err)
      })
    }
  },
  watch: {
  },
  filters: {
    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    }
  }
}
</script>
<style scoped>
.light {
  color: #fcfcfc !important;
}
</style>
